/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum MediaStreamType {
  Main = "MAIN",
  Trial = "TRIAL",
}

export enum MediaType {
  Advertisement = "ADVERTISEMENT",
  Album = "ALBUM",
  Article = "ARTICLE",
  Category = "CATEGORY",
  Channel = "CHANNEL",
  Club = "CLUB",
  Competitions = "COMPETITIONS",
  Episode = "EPISODE",
  Event = "EVENT",
  FootballEvent = "FOOTBALL_EVENT",
  FootballSeason = "FOOTBALL_SEASON",
  Intro = "INTRO",
  League = "LEAGUE",
  Live = "LIVE",
  Match = "MATCH",
  MovieNight = "MOVIE_NIGHT",
  Package = "PACKAGE",
  Person = "PERSON",
  Player = "PLAYER",
  Podcast = "PODCAST",
  Premiere = "VIDEO_PREMIERE",
  Program = "PROGRAM",
  Season = "SEASON",
  Series = "SERIES",
  Team = "TEAM",
  Video = "VOD",
}

export enum AssetPlaybackStatus {
  Starting = "STARTING",
  Streaming = "STREAMING",
  Paused = "PAUSED",
  Stopped = "STOPPED",
  Ended = "ENDED",
}

export enum MediaImageType {
  Cover = "COVER",
  Frame = "FRAME",
  Highlights = "HIGHLIGHTS",
  Square = "SQUARE",
  Background = "BACKGROUND",
  Round = "ROUND",
  Landscape = "LANDSCAPE",
}

export enum PlayerControllerType {
  THEOPlayer = "THEOPLAYER",
  VideoJsPlayer = "VIDEOJSPLAYER",
  Mycujoo = "MYCUJOO",
  JWPlayer = "JWPLAYER",
  ShakaPlayer = "SHAKAPLAYER",
  Flowplayer = "FLOWPLAYER",
}

export enum PlayerUIType {
  Standalone = "STANDALONE",
  Custom = "CUSTOM",
}
